var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18V17.35C4.5 17.01 4.66 16.69 4.91 16.54C6.6 15.53 8.53 15 10.5 15C10.53 15 10.55 15 10.58 15.01C10.68 14.31 10.88 13.64 11.17 13.03C10.95 13.01 10.73 13 10.5 13C8.08 13 5.82 13.67 3.89 14.82C3.01 15.34 2.5 16.32 2.5 17.35V20H11.76C11.34 19.4 11.01 18.72 10.79 18H4.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12C12.71 12 14.5 10.21 14.5 8C14.5 5.79 12.71 4 10.5 4C8.29 4 6.5 5.79 6.5 8C6.5 10.21 8.29 12 10.5 12ZM10.5 6C11.6 6 12.5 6.9 12.5 8C12.5 9.1 11.6 10 10.5 10C9.4 10 8.5 9.1 8.5 8C8.5 6.9 9.4 6 10.5 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2499 16C21.2499 15.78 21.2199 15.58 21.1899 15.37L22.3299 14.36L21.3299 12.63L19.8799 13.12C19.5599 12.85 19.1999 12.64 18.7999 12.49L18.4999 11H16.4999L16.1999 12.49C15.7999 12.64 15.4399 12.85 15.1199 13.12L13.6699 12.63L12.6699 14.36L13.8099 15.37C13.7799 15.58 13.7499 15.78 13.7499 16C13.7499 16.22 13.7799 16.42 13.8099 16.63L12.6699 17.64L13.6699 19.37L15.1199 18.88C15.4399 19.15 15.7999 19.36 16.1999 19.51L16.4999 21H18.4999L18.7999 19.51C19.1999 19.36 19.5599 19.15 19.8799 18.88L21.3299 19.37L22.3299 17.64L21.1899 16.63C21.2199 16.42 21.2499 16.22 21.2499 16ZM17.4999 18C16.3999 18 15.4999 17.1 15.4999 16C15.4999 14.9 16.3999 14 17.4999 14C18.5999 14 19.4999 14.9 19.4999 16C19.4999 17.1 18.5999 18 17.4999 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminConfig);
export default __webpack_public_path__ + "static/media/admin-config.dcae765bbd9e8695da0b445afb5bf7ee.svg";
export { ForwardRef as ReactComponent };